// Mirrors the server-side order payment gate (olc-server order-payment-gate.service.js).
const PAYMENT_METHOD_REQUIRED_CODE = 'PAYMENT_METHOD_REQUIRED';

/**
 * Live-mode orders need a default card on file; test-mode orders are never charged.
 * Fails open while the organization is not loaded so the server stays the source of truth.
 */
export const isPaymentMethodMissing = (user) =>
  user?.isLiveMode === true &&
  !!user.organization &&
  !user.organization.defaultPaymentMethodStripeId;

/**
 * Re-reads the account before the "add a card" modal blocks an order. The cached account can lag
 * behind a card that was just saved: the server sets the default card in a background task and
 * `auth/me` reads a replica, so the refetch right after saving often still shows no card.
 * `refreshUser` is a getUserData-style call that resolves to the axios response. A failed refresh
 * has no `data.data`, so this fails open and the server's 422 stays the safety net.
 */
export const isPaymentMethodStillMissing = async (refreshUser) => {
  const response = await refreshUser();
  return isPaymentMethodMissing(response?.data?.data);
};

/** True when an API response (axios `response`) is the server's "add a card first" rejection. */
export const isPaymentMethodRequiredResponse = (response) =>
  response?.status === 422 && response?.data?.data?.code === PAYMENT_METHOD_REQUIRED_CODE;
